import Local from "@/utils/local";
// import store from '@/store';
export default {
  getUUID() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
      return (c === "x" ? (Math.random() * 16) | 0 : "r&0x3" | "0x8").toString(
        16
      );
    });
  },
  parse(data) {
    if (data) {
      let result = null;
      if (data && data["code"]) {
        if (data["code"] === "0") {
          result = data || {};
        } else if (data["code"] === "401") {
          window._vueW.$router.push({ name: "login" });
        } else {
          result = data || {};
        }
      } else {
        result = data;
      }
      return result;
    }
  },
  paramFormat(data = {}) {
    let result = {};
    if (data.page) data.page = String(data.page);
    if (data.limit) data.limit = String(data.limit);
    result = JSON.stringify(data);
    return result;
  },
  getParamFormat(result) {
    return result;
  },
  /**
   * Get方式格式化参数
   * @param data
   */
  GetParamFormat(data = {}) {
    return { params: data };
  },
  getToken() {
    let vuex = Local.getItem("vuex") || {};
    let _token = "";
    if (vuex["token"]) _token = vuex["token"];
    return _token;
  },
  getUserId() {
    let vuex = Local.getItem("vuex") || {};
    let userId = "";
    if (vuex["user"] && vuex["user"]["userId"]) userId = vuex["user"]["userId"];
    return userId;
  },
  checkUserRoleAdmin() {
    let adminId = 1;
    let vuex = Local.getItem("vuex") || {};
    if (vuex["user"] && vuex["user"]["roleIdList"]) {
      let roleIdList = vuex["user"]["roleIdList"];
      let idx = 0;
      for (idx in roleIdList) {
        let itemId = roleIdList[idx];
        if (itemId == adminId) {
          return true;
        }
      }
    }
    return false;
  },
  getRoleAuth(userState, auth) {
    let user = userState.user;
    let menuIdList = user.menuIdList;
    let idx = 0;
    for (idx in menuIdList) {
      let menuId = menuIdList[idx];
      if (menuId == auth) {
        return true;
      }
    }
    return false;
  }
};
